
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FRONTPAGE_SETTINGS"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"position"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frontpageSettings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blogName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"blogDesc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showDataCenter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tickerTag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tickerTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"livestream"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showCountdownComponent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countdownComponent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countdownExpires"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"livetickerSlug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showRegionalQuestionaireWidget"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iosWhitelist"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"androidWhitelist"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"getSidebars"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"request"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}},{"kind":"Argument","name":{"kind":"Name","value":"position"},"value":{"kind":"Variable","name":{"kind":"Name","value":"position"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widgets"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"component"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"props"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"initialData"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"posInMainFeed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showOnMobile"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":571}};
    doc.loc.source = {"body":"# Write your query or mutation here\nquery FRONTPAGE_SETTINGS($request: String, $position: String) {\n  frontpageSettings {\n    blogName\n    blogDesc\n    showDataCenter\n    tickerTag\n    tickerTitle\n    livestream\n    showCountdownComponent\n    countdownComponent\n    countdownExpires\n    livetickerSlug\n    showRegionalQuestionaireWidget\n    iosWhitelist\n    androidWhitelist\n  }\n  getSidebars(request: $request, position: $position) {\n    position\n    widgets {\n      component\n      props\n      initialData\n      posInMainFeed\n      showOnMobile\n      title\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["FRONTPAGE_SETTINGS"] = oneQuery(doc, "FRONTPAGE_SETTINGS");
        
